const mediaItems = [
  {
    title: '时空穿梭者：纪元重启',
    tag: '科幻巨制',
    duration: '2:35',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20trailer%20thumbnail%20with%20futuristic%20city%20and%20time%20portal%20visual%20effects%2C%20dramatic%20lighting%2C%20epic%20movie%20poster%20style%2C%20warm%20golden%20highlights&width=600&height=340&seq=media-trailer-01&orientation=landscape',
  },
  {
    title: '暗夜追踪者',
    tag: '悬疑推理',
    duration: '1:58',
    img: 'https://readdy.ai/api/search-image?query=Dark%20noir%20thriller%20trailer%20thumbnail%2C%20rainy%20urban%20scene%20with%20detective%20figure%2C%20moody%20cinematic%20lighting%2C%20film%20noir%20aesthetic&width=600&height=340&seq=media-trailer-02&orientation=landscape',
  },
  {
    title: '夏日的约定',
    tag: '浪漫爱情',
    duration: '1:42',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20film%20trailer%20thumbnail%20with%20soft%20summer%20sunlight%20and%20cherry%20blossoms%2C%20warm%20nostalgic%20tone%2C%20dreamy%20cinematic%20quality&width=600&height=340&seq=media-trailer-03&orientation=landscape',
  },
  {
    title: '武林风云录',
    tag: '动作大片',
    duration: '2:10',
    img: 'https://readdy.ai/api/search-image?query=Epic%20wuxia%20trailer%20thumbnail%20with%20bamboo%20forest%20and%20dynamic%20martial%20arts%20action%2C%20dramatic%20composition%2C%20cinematic%20lighting&width=600&height=340&seq=media-trailer-04&orientation=landscape',
  },
  {
    title: '我的机器人室友',
    tag: '爆笑喜剧',
    duration: '1:35',
    img: 'https://readdy.ai/api/search-image?query=Comedy%20film%20trailer%20thumbnail%20with%20robot%20and%20human%20in%20modern%20apartment%2C%20bright%20warm%20lighting%2C%20quirky%20humorous%20moment&width=600&height=340&seq=media-trailer-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            精彩预告
          </h2>
          <p className="mt-2 text-sm text-foreground-500">热门影片预告抢先看，精彩不容错过</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group block rounded-xl bg-background-50 border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all cursor-pointer no-underline"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {/* Play button overlay */}
                <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/10 transition-colors">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                {/* Duration badge */}
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/70 text-white text-xs">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-1 truncate">{item.title}</h3>
                <span className="text-xs text-foreground-500">{item.tag}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}